




































import { Component, Vue, PropSync } from 'vue-property-decorator'

@Component
export default class SearchRequestNoDialogComponent extends Vue {
  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  /** バリデーション */
  invalid = false

  /* 受付番号 */
  requestNo = ""

  /**
   * 初期化
   */
  reset() {
    this.requestNo = ""
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.requestNo)
    this.reset()
  }

}
